import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { StatsSection } from './components/StatsSection';
import { ServicesSection } from './components/ServicesSection';
import { WhyChooseUs } from './components/WhyChooseUs';
import { ClientsSection } from './components/ClientsSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-navy text-white selection:bg-jml-orange selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <StatsSection data-id="element-5" />
        <ServicesSection data-id="element-6" />
        <WhyChooseUs data-id="element-7" />
        <ClientsSection data-id="element-8" />
        <CTASection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}